export default {
  titles: {
    encoding: 'コード化',
    inbound: 'インバウンド',
    user_info: 'ユーザー情報',
    settings: '設定',
    reset_daily_items: '日常アイテムをリセットする',
    last_parcels: 'ラストパーセルズ',
    select_item: 'アイテムを選択',
    select_workstation: 'ワークステーションの選択',
    select_language: '言語の選択',
    support: 'サポート',
    select_printer: 'プリンターの選択',
    shipment_to_confirm: 'シップメント確認',
    sorting_details: 'ベンチレーション詳細',
    inventories: 'インベントリ',
    pin_modal: 'ピンを入力して関連付けを強制します',
    shipments: 'シップメント',
    report_problem: '問題を報告する',
    parcels: '小包',
    //moncler
    outbound_bthp: 'アウトバウンドBTHP証明書'
  },
  simple_parcel_list: {
    to_read: '読み取り',
    ok: 'OK',
    force: '強制',
    force_parcel: '小包{{code}}を強制',
    force_parcel_desc: '小包を強制するにはユーザーPINを入力してください',
    forced: '強制済み',
    unexpected: '予期しない',
    remove: '削除',
    invalid_pin: 'ユーザーPINが無効です',
    loading: '小包リストを読み込み中'
  },
  create_parcel_gate: {
    //moncler
    width: '幅',
    height: '高さ',
    depth: '奥行き',
    tare: '容器重量',
    description: '説明'
  },
  fields: {
    current_location: '現在位置',
    identified_item: '識別されたアイテム',
    ignored_items: '無視されるアイテム',
    ignored_with_reason_items: '理由付きで無視されるアイテム',
    error_items: 'エラーアイテム',
    warning_items: '警告アイテム',
    umg: 'Umg',
    custom_class: 'カスタムクラス',
    product_code: '製品コード',
    as400username: 'ユーザー名 AS400',
    item_components: 'コンポーネント',
    //valentino
    mission: 'ミッション',
    mission_type: 'ミッションタイプ',
    supplier: 'サプライヤー',
    physical_storage: '物理保管',
    season: 'シーズン',
    ddt: 'DDT',
    notification: '通知',
    ddt_date: 'DDT日付',
    notification_date: '通知日付',
    product_category: '製品カテゴリ',
    sender: '送信者',
    year: '年',
    number: '番号',
    row: '行',
    entity: 'エンティティ',
    labels: 'ラベル'
  },
  misc: {
    select_an_option: 'オプションを選択...',
    not_set: '未設定',
    current_value: '現在の値',
    pleaseWait: 'お待ちください',
    not_associated: '関連付けられていません',
    replaced: '置換済み',
    production_order_info: '製造オーダー情報',
    reel_info: 'リール情報',
    reel_code: 'リールコード',
    assigned_supplier: '割り当てられたサプライヤー',
    type: 'タイプ',
    identifier_info: '識別子情報',
    identifier_events: '識別子イベント',
    or: 'または',
    select_place: 'こんにちは {{user}}、続行するには起源地を選択してください',
    back: '戻る',
    refresh: 'リフレッシュ',
    reload: 'リロード',
    save: '保存',
    confirm: '確定',
    confirm_auto: '自動確定',
    update_and_confirm: '更新して確定',
    update: '更新',
    no_carton_found: 'カートンが見つかりません',
    confirm_continue: '確定して続行',
    cancel: 'キャンセル',
    close: 'クローズ',
    user: 'ユーザー',
    workstation: 'ワークステーション',
    username: 'ユーザー名',
    name: '名前',
    password: 'パスワード',
    login: 'ログイン',
    encoding: 'コード化',
    code: 'コード',
    ean_code: 'EANコード',
    certilogo: 'サーティロゴ',
    enter_the_necessary_fields: '必要なフィールドに入力して操作を開始します',
    associated_items: '関連アイテム',
    associate: '関連付ける',
    associated: '関連付けられた',
    verify: '確認する',
    verify_association: '確認する',
    reading: '読み込む',
    processing: '処理',
    association: '関連',
    associations: '関連',
    waiting: '待機',
    writing: '書き込み',
    writing_progress: '書き込み進行中...',
    partial_confirm: '部分確定',
    retry: '再試行',
    writing_association: '書込みと関連付け',
    confirmed: '確定済み',
    unable_to_write: '製品: {{productCode}} の epc タグ: {{code}} を書き込めません',
    unable_to_get_next_epc: '次の EPC を取得できません: {{productCode}}',
    unable_to_connect_to_workstation: 'ワークステーションに接続できません',
    tag_info: 'タグ情報',
    inbound: 'インバウンド',
    outbound: 'アウトバウンド',
    stop: '停止',
    start: '開始',
    pause: '一時停止',
    clear: 'クリア',
    tag_encoded_today: '今日のタグエンコード',
    transaction_date: '取引日',
    select_transaction_date: '取引日を選択してください',
    ready_to_receive: '受け取り準備完了',
    change_password: 'パスワードを変更する',
    logout: 'ログアウト',
    are_you_sure_to_logout: '本当にログアウトしますか？',
    settings: '設定',
    roles: '役割',
    role: '役割',
    email: 'Eメール',
    place: '場所',
    items: '複数アイテム',
    description: '説明',
    color: 'カラー',
    size: 'サイズ',
    part: '一部',
    total_reads: '合計読み取り数',
    total_ok: '全く問題ありません',
    save_to_list: 'リストに保存',
    destination: '送り先',
    origin: '起源',
    new_parcel: '新しいパーセル',
    status: '状態',
    parcel: 'パーセル',
    read_parcel: 'パーセルを読み込む',
    parcels: 'パーセル',
    shipment: 'シップメント',
    creation_date: '作成日',
    search: '検索',
    select_search: '検索...',
    detail: '詳細',
    quantity: '数量 ({{quantity}})',
    only_quantity: '数量',
    style: 'スタイル',
    material: 'マテリアル',
    shipment_code_auto: 'シップメントコード (自動)',
    parcel_code_auto: 'パーセルコード（自動）',
    next: '次',
    parcels_to_receive: '受領するパーセル',
    confirm_parcel: 'パーセルの確定',
    image_missing: '画像がありません',
    image: '画像',
    loading: '読み込み中...',
    unknown_product: '不明な製品',
    unknown_tag: '不明なタグ',
    invalid_tag: '無効なタグ',
    virgin_tag: 'ヴァージンタグ',
    tag_not_associated: 'タグが関連付けられていません',
    killed: '殺された',
    stock: 'ストック',
    valid: '有効',
    unknown: '未知',
    actions: 'アクション',
    reprint: '再印刷',
    product: '製品',
    product_items: '製品アイテム',
    identifiers: '識別子',
    zone: 'ゾーン',
    location: 'ロケーション',
    report_repair: '修理の報告',
    reason: '理由',
    request_code_change: 'コード変更のリクエスト',
    enable_workstation_emulation: 'ワークステーションエミュレーションを有効にする',
    enable_browser_print_emulation: 'ブラウザ印刷エミュレーションを有効にする',
    filter: 'フィルター',
    language: '言語',
    warning: '警告',
    success: '成功',
    info: '情報',
    checklist: 'チェックリスト',
    optional: 'オプション',
    phone: '電話',
    version: 'バージョン',
    printer: 'プリンター',
    new_shipment: '新しいシップメント',
    upc: 'UPC',
    model_part_color_size: 'モデル/パーツ/カラー/サイズ',
    confirm_shipment: 'シップメントの確定',
    receive: '受領',
    delete: '削除',
    delete_association: '削除',
    change: '変更',
    from: 'から',
    to: 'まで',
    ignored: '無視',
    skipped: 'スキップ',
    ignored_with_reason: '理由をつけて無視される',
    yes: 'はい',
    no: 'いいえ',
    model: 'モデル',
    typology: 'タイポロジィ',
    no_result: '検索結果はありません',
    expected: '予測される',
    expected_plural: '予測される',
    read: '読む',
    missing: '不足',
    unexpected: '予想外',
    unexpected_parcel: '予期しないパーセル',
    ignored_plural: '無視',
    serial: 'シリアル',
    priority: '優先度',
    group: 'グループ',
    required_quantity: '必要数量',
    sorted_quantity: 'ベンチレーション数量',
    missing_quantity: '不足数量',
    barcode: 'バーコード',
    barcode_bc: 'バーコードBC',
    sorted_date: 'ベンチレーション日',
    customer: '顧客名',
    list: 'リスト',
    list_position: 'リストの位置',
    select_date: '日付を選択してください',
    item_info: 'アイテム情報',
    item_identifier_info: 'アイテム識別子情報',
    item_identifier_events: 'アイテム識別子イベント',
    item_events: 'アイテムイベント',
    operation_type: '操作タイプ',
    operation_place: '操作場所',
    loading_data: 'データをロード中です。お待​​ちください。',
    empty_item_events: 'イベントが見つかりませんでした',
    show_more: 'もっと表示する',
    hide_more: 'もっと非表示する',
    production_order: '製造オーダー',
    production_order_detail: '製造オーダー詳細',
    production_order_row: '製造オーダー行',
    production_order_sku: '製造オーダーのSKU',
    kill_tag: 'タグの削除',
    replace_tag: 'タグの置換',
    replace_tag_with: 'タグを置換する {{tag}}',
    item_po: 'アイテムの親オーダー',
    item_order: 'アイテムの注文',
    item_row: 'アイテム行',
    pack_code: 'パッケージコード',
    send_reads: '読み取りの送信',
    items_add_inventory_success: '在庫にアイテムが追加されました',
    new: '新しい',
    confirm_mission: 'ミッションを確定する',
    confirm_mission_text: 'ミッションを確定してもよろしいですか？',
    parziali: '部分的',
    total_quantity: '総量',
    accepted_quantity: '受領数量',
    country_check: '国の管理',
    showcase_check: 'ショーケース管理',
    attention: '注意',
    clear_items: '続行するとすべての測定値が削除されます。続行しますか?',
    add_partial: '注意',
    add_partial_text: '品質保証ミッションの作成が必要になる場合があります',
    add_partial_already_text:
      '品質保証ミッションの作成が必要になる場合があります。 UMGはすでに機能しています。読み込んだアイテムを上書きしますか?',
    error_cq_mission: '注意、品質管理のミッションを作成する',
    warning_zone_items: 'IN_ANOTHER_ZONE',
    internal_tag: '内部タグ',
    external_tag: '外部タグ',
    error_tag: 'エラータグ',
    awaiting: '待機',
    error_logs: 'エラーログ',
    event_logs: 'イベントログ',
    box_closed: 'クローズされたボックス',
    box_out: 'ボックスアウト',
    unexpected_list: '予想外のアイテムリスト',
    pending_tags: '保留中のタグ',
    selected_zone: '選択されたゾーン',
    pricing: '価格設定',
    send_to_sap: 'SAPに送信',
    write_tag: 'タグの書き込み',
    identifier_tag: '識別タグ',
    digit_identifier_tag: '書き込む数字タグ',
    target_epc: 'ターゲットEPC',
    retry_write_tag: '書き込み処理中にエラーが発生しました。もう一度試しますか?',
    ready: '準備',
    offline: 'オフライン',
    shipping_date: 'Shipping Date',
    update_only_product: 'Item already associated to another product. Are you sure do you want to overwrite it ?',
    update_production_order_row:
      'Item already associated to another production order row. Are you sure do you want to overwrite it ?',
    export: 'Export',
    select_zone: 'Select zone',
    location_origin: 'Location origin',
    confirm_kill_tag: 'Which tags do you want to Kill?',
    kill_in_progress: 'Killing tags in progress',
    confirm_replace_tag: 'Which tags do you want to Replace?',
    replace_in_progress: 'Replacing tags in progress',
    select_tag_to_kill: 'Select the tag you want to kill',
    disassociating_item: 'Disassociating Item',
    killing_tag: 'Killing {{type}} tag with role {{role}}',
    retry_kill_tag: 'A killing error was encountered. Do you want to try killing the tag again?',
    reading_tag: 'Reading Tag',
    writing_tag: 'Writing Tag',
    writing_tag_with: 'Writing tag {{tag}}',
    navBackWarning: 'Are you sure you want to go back? All unsaved changes, such as readings, will be lost.',
    sentry: {
      report_problem: '遭遇した問題を記述するか、改善を提案してください'
    },
    ready_to_read: 'Ready to read',
    remove_product_readings: 'Remove product readings',
    ok: 'OK',
    already_in_parcel: 'already in parcel',
    operation_canceled_by_user: 'Operation canceled by user',
    load_more: 'loading in progress',
    input: 'Input',
    rfid_barcodes: 'RFID Barcodes',
    submit: 'Submit',
    //valentino
    error: 'エラー',
    OK_WORKER: '作業者OK',
    KO_WORKER: '作業者KO',
    OK_REPAIR: '修理OK',
    RESO_RICHIESTO_CQ: 'QCリクエスト',
    RESO_OK: '返品OK',
    OK_VALDAGNO: 'ヴァルダーニョOK',
    KO_VALDAGNO: 'ヴァルダーニョKO',
    SECOND_VALDAGNO: '第二選択',
    OK_LINING: 'ライニングOK',
    ok_first_inbound_status: '最初のインバウンドOK',
    OK_RISC: 'リスクOK',
    KO_LINING: 'ライニングKO',
    size_color: 'サイズ/カラー',
    select_size_color: 'サイズ/カラーを選択',
    print: '印刷',
    missings: '不足項目',
    embedded: '埋め込み',
    ignoreds: '無視項目',
    select_printer: 'プリンターを選択',
    printing_started: '印刷開始',
    release_reports: 'リリースレポート',
    quality_checks: '品質チェック',
    quality_check: '品質チェック',
    total_mission_qty: 'ミッション合計数量',
    inbound_read_qty: 'ゲート読み取り数量',
    checked_qty: '検査済み数量',
    checked: '検査済み',
    returned: '返却済み',
    damaged: '損傷',
    qty_damaged_first_check: '1次検査損傷数',
    first_check_date: '1次検査日',
    qty_damaged_second_check: '2次検査損傷数',
    second_check_date: '2次検査日',
    note: 'ノート',
    work_order: '作業指示',
    order_type: '注文タイプ',
    //louis vuitton
    start_and_read: 'アンテナを起動して製品を配置してください',
    emulate: 'エミュレート',
    advanced_emulation: '高度なエミュレーション',
    emulation_history: 'エミュレーション履歴',
    emulation_favorites: 'エミュレーションお気に入り',
    power: '出力',
    sensitivity: '感度',
    expected_quantity: '期待数量',
    extra_quantity: '余分な',
    encoded_quantity: 'エンコード',
    clear_and_restart: 'クリアと再起動',
    products: '製品',
    last_paired_sn: '最後にペアリングされたSN',
    last_confirmed_ucs: '最後に確認されたUCS',
    user_manual: 'ユーザーマニュアル',
    operation_user_manual: '操作ユーザーマニュアル',
    activity: '活動',
    encodings: 'エンコーディング',
    progress: '進捗',
    encoding_user: 'エンコードユーザー',
    encoding_place: 'エンコード場所',
    total_encodings: 'エンコード合計',
    sizes: 'サイズ'
  },
  error: {
    error: 'エラー',
    errors: 'エラー',
    forbidden: '禁止',
    not_found: '見つかりません',
    product_not_found: '製品が見つかりません',
    unauthorized: '無許可',
    too_many_tags_read: '読み取られたタグが多すぎます (期待値 {{expected}} が {{read}} を読み取りました)',
    too_many_checklist_types: 'チェックリストの種類が多すぎます。同じチェックリストタイプの小包を選択してください',
    rfid_discrepancies_found: 'RFID の不一致が見つかりました。すべてクリアして再試行するか、不一致を確認してください。',
    certilogo_not_found: 'サーティロゴ"{{code}}"が見つかりません"',
    ean_not_found: '"EAN"{{code}}"が見つかりません"',
    production_order_not_found: '製造オーダー"{{code}}"が見つかりません"',
    no_inbound_zones: 'インバウンドゾーンがありません',
    no_operation_config: '動作設定が見つかりません',
    not_supported_reading_mode: '読み取りモードはサポートされていません',
    undefined_operation_config: '操作構成を定義解除することはできません',
    certilogo_already_encoded: 'サーティロゴ"{{code}}"はすでにエンコードされています"',
    tag_not_found: 'タグが見つかりません',
    missing_printer_id: 'プリンターIPがありません',
    tag_unassociated: 'タグが関連付けられていません',
    tag_type_unexpected: '予期しないタグの種類',
    tag_already_associated: 'タグはすでに関連付けられています',
    tags_not_associated: '1 つ以上のタグが関連付けられていません',
    tags_mismatch: 'タグが一致しません',
    workstation_could_not_be_started: 'ワークステーション {{code}} を起動できませんでした',
    antenna_was_started: 'アンテナ {{code}} が開始されました',
    antenna_was_not_started: 'アンテナ {{code}} は起動されていません',
    authentication_failed: '認証に失敗しました',
    field_required: 'フィールド {{label}} は必須です',
    unable_to_connect_to_rfid_reader: 'RFIDリーダーに接続できません。デバイスの電源を確認してください。',
    items_in_error_found: 'エラーのあるアイテムが見つかりました',
    item_not_in_inbound: 'アイテムが受領されていません',
    item_not_in_stock: '在庫がない商品',
    item_in_another_parcel: '別のパーセル内のアイテム',
    item_in_another_production_order: '別の製造オーダーのアイテム',
    connection: '接続エラー',
    connection_details:
      'サーバーから応答がありませんでした。インターネット接続または VPN 構成が機能していることを確認してください。',
    field_invalid_default: 'フィールド {{field}} のデフォルト値"{{defaultValue}}"が無効です"',
    field_invalid: 'フィールド {{field}} の値が無効です',
    field_invalid_default_from_endpoint: 'フィールド {{field}} の値が見つかりませんでした',
    sorting_already_read: 'シリアル番号 {{serial}} のアイテムはグループ {{group}} ですでに読み取られています',
    sorting_no_group: 'アイテムはソートできません',
    sorting_not_in_zone: 'シリアル番号 {{serial}} のアイテムは並べ替えできません。すでにゾーン {{zone}} 内にいます',
    sorting_unknown: 'タグ {{tag}} は無効です',
    sorting_unexpected: '予期しないタグ',
    no_item_configuration: 'アイテム構成が見つかりません',
    item_creation_error: 'アイテム作成エラー',
    couldn_find_production_order: '製造オーダーが見つかりませんでした',
    couldn_find_work_order: '工順が見つかりませんでした',
    couldn_find_production_order_row: '製造オーダーの行が見つかりませんでした',
    missing_operation_option: '操作オプションがありません: {{error}}',
    item_session_list_create: '未作成のリスト',
    item_session_list_create_session: '未作成のセッションリスト',
    item_session_list_confirm: '未確認リスト',
    item_session_list_confirm_session: '未確認セッションリスト',
    form_validation: '検証フォーム',
    form_validation_message: 'フィールドへの入力エラー',
    select_place_error: '起源地を保存できませんでした',
    self_user_data: 'データを保存できませんでした',
    encoding_no_tags: 'これ以上タグは読み取られませんでした。操作は中止されました。',
    timeout_no_reads: 'タグ/製造オーダーが検出されませんでした。製品をアンテナに近づけて再起動してください',
    only_virgin_tag: 'バージンタグのみが検出されました',
    tags_mismatch_error: '検出された製品が多すぎます',
    tags_mismatch_workorder: 'ワークオーダー行の不一致',
    tags_errors: 'タグエラー',
    value_not_valid: '入力された値は無効です',
    write_tag: 'タグの書き込み中に不明なエラーが発生しました',
    WRONG_PRODUCTION_ORDER: '不正な製造順序',
    WRONG_PLACE: '不正な場所',
    PRODUCTION_ORDER_ROW_CREATION_ERROR: '製造オーダー行作成エラー',
    force_tag_associated: 'タグはすでに関連付けられています。再度関連付けますか?',
    operation_confirm_error: '動作確認エラー',
    missing_mandatory_qc: '品質管理はありません。続行しますか？',
    wrong_qc_status: 'この製品はKOと宣言されました。続行しますか？',
    wrong_qc_size: 'サイズを確認してください。続行しますか？',
    wrong_qc_size_payload: 'エンコーディングサイズ：{{Productize}}  - 物理サイズ：{{ManualSize}}。続く？',
    wrong_qc_model: 'モデルを確認してください。続行しますか？',
    start_checklist: '未開始チェックリスト',
    confirm_with_unexpected: '予期しないタグで確定できません',
    confirm_with_overqty: '数量を超えたタグでは確定できません',
    rfid_reader_initialization: 'RFIDリーダーの初期化中に不明なエラーが発生しました',
    remove_sap_item_error: 'アイテムを削除できません',
    no_asn_selected: 'ASNが選択されていません',
    submit_asn: 'ASN送信エラー',
    zbpNotFound: 'Zebra Browser Printが見つかりません。インストールされて実行されていることを確認してください',
    no_printer_selected: 'プリンターが選択されていません',
    zplTemplateNotDefined:
      'ZPLテンプレートが定義されていません。操作設定の「zpl-template-code」属性にテンプレートコードを設定してください',
    no_print_template: '印刷テンプレートが見つかりません',
    wrong_tag: '不正なタグ',
    tag_error_or_not_authentic: 'タグが正規ではないか認証エラーです',
    authentication_timeout: '認証がタイムアウトしました',
    tid_missing: '読み取ったタグのTidが見つかりません',
    on_destination: '宛先 {{destination}} で',
    item_not_sortable: 'シリアル{{serial}}のアイテムは振り分けできません',
    search_error: '検索エラー',
    no_parcel_found_by_identifier: 'この識別子のパーセルが見つかりません',
    kill_tag_not_allowed:
      'アイテムに関連付けられたタグは消去できません。タグを消去するには、まずアイテムの関連付けを解除してください。',
    kill_already_killed: 'ラベルはすでに削除されています',
    can_kill_only_tag_type: '{{type}}タグのみ破壊可能',
    replace_tag_not_allowed: 'アイテムに関連付けられたタグのみ置換可能です',
    kill_tag_not_success: 'タグの消去に失敗しました',
    replace_tag_not_success: 'タグの置換に失敗しました',
    nfc_tag_not_expected: 'この製品にはNFCタグは想定されていません',
    ventilation_quantity_reached: 'この製品のベンチレーション数量の上限に既に達しています',
    confirm_not_allowed_with_errors: 'エラーがある状態では確定できません',
    close_not_allowed_with_errors: 'エラーがある状態ではクローズできません',
    generic: 'フィードバックの送信中にエラーが発生しました',
    form_entry: '必須フィールドが未入力です',
    invalid_tag_read: '無効なタグを読み取りました',
    read_one_tag_time: '一度に一つのタグのみ読み取ってください',
    validation_failed_rewrite: 'リライト設定のバリデーションに失敗しました',
    uhf_tag_not_found: 'UHFタグが見つかりません',
    compute_tags_failed: '書き込み用タグの生成に失敗しました',
    be_generic_error: 'システムエラー',
    be_generic_error_description: 'システムで一般的なエラーが発生しました',
    identifier_production_order_not_found: '製造オーダーが見つかりません',
    gs1code_invalid: 'GS1コードが無効です',
    productionorderrow_mismatch: '製造オーダー行の不一致。続行しますか？',
    //cucinelli
    nfc_already_associated: 'NFCは既に関連付けられています。関連付けを解除して操作をやり直してください',
    too_many_valid_tag_read: '有効なタグが多すぎます',
    fields_required: 'は必須です',
    exceeded_quantity: '数量超過',
    production_order_completed: '製作注文が完了しました',
    work_order_completed: '製作注文が完了しました',
    production_order_row_completed: '製造オーダーの行が完成しました',
    work_order_row_completed: '製造オーダーの行が完成しました',
    replace_tag_not_allowed_for_this_tag: '无法替换此类标签',
    box_already_received: '箱はすでに受け取られています。読み飛ばしてください。',
    MISSING_EAN_ATTRIBUTE: '商品{{productCode}}のEANが見つかりません',
    other_production_order: '別の製造オーダーと製品に既に関連付けられています',
    workorder_mismatch:
      '製品SKUが包装に記載されたものと一致しません - 包装内の製品が正しいことを確認し、関連付けを進めてください'
  },
  messages: {
    no_operations_found: '操作が見つかりませんでした。コントロールパネルでユーザー権限を確認してください',
    not_allowed_operation: 'この操作を実行する権限がありません。設定を確認してください',
    no_workstations_found: 'ワークステーションが見つかりません',
    no_workstation_selected: 'ワークステーションが選択されていません',
    are_you_sure_to_reset_daily_items: '日次アイテムをリセットしてもよろしいですか?',
    bring_an_item_to_antenna: 'アンテナにアイテムを近づけてください',
    press_start_to_read: '[スタート]ボタンを押して、RFID 製品の読み取りを開始します',
    reading_in_progress: '読み取り中',
    waiting_for_product: '商品を待っています...',
    paste_comma_separeted_tags: 'カンマ区切りタグを貼り付けて、Return キーを押します...',
    connection_workstation_progress: 'ワークステーションへの接続が進行中です…',
    operation_success: '操作は正常に完了しました',
    outbound_success: 'アウトバウンドが正常に確定されました',
    inbound_success: 'インバウンドが正常に確定されました',
    pack_success: 'パッキングが正常に確定されました',
    transfer_to_zone_success: 'ゾーンへの転送が正常に確定されました',
    simple_item_list_success: 'シンプルアイテムリストが正常に確定されました',
    list_empty: 'リストが空です',
    looks_like_anything_in_list: 'リストには何もないようです',
    generic_success: '{{code}} が正常に確定されました',
    generic_success_canceled: '{{code}} は正常にキャンセルされました',
    generic_error: '{{code}} エラー',
    fill_all_fields_and_search_an_item_configuration: 'すべてのフィールドに入力し、アイテム構成を検索します',
    encoding_success: 'エンコードが正常に完了されました',
    encoding_success_none: 'アイテムはすでに以前に関連付けられています',
    read_some_identifier_to_start_verification: '識別子を読み取って検証を開始します',
    warning_items_found: '警告アイテムが見つかりました',
    are_you_sure_you_want_to_confirm: '本当に確定してもよろしいですか？',
    item_session_list_confirm: 'リストは正常に確定されました',
    operation_in_progress: '操作が進行中です。お待​​ちください...',
    sorting_error_zones: '起源ゾーンが評価されず、循環を継続するのは不可能です',
    connection_in_progress: '接続中...',
    checklist_there_are: 'がある',
    checklist_missings: '不足アイテム',
    checklist_overqty: '超過アイテム',
    checklist_unexpecteds: '予期しないアイテム',
    checklist_confirm_mismatch_question: '本当に確定してもよろしいですか?',
    force_update_content: 'SAP に強制的に送信してもよろしいですか?',
    connection_to_station_in_progress: 'ステーションに接続中です',
    tag_killed: 'タグは破壊されました',
    tag_replaced: 'Tag replaced',
    tag_deleted: 'タグが削除されました',
    write_tag: 'タグの書き込みに成功しました',
    not_ready: 'Non pronta',
    readyf: 'Pronta',
    nfcDecryption: 'Decrittazione tag NFC. Tenere il tag fermo, per favore',
    parcel_success: 'Parcel confermato con successo',
    sentry: {
      success: 'Grazie per il tuo feedback! Il tuo contributo ci aiuta a migliorare il servizio.'
    },
    confirm_force_shipment: 'Conferma la spedizione con PFAS',
    input_rfid_barcodes: 'Inserire i barcode RFID, separati da virgola o accapo',
    //valentino
    are_you_sure_to_clear_reads: 'Sei sicuro di voler cancellare le letture?',
    are_you_sure_to_confirm: 'Sei sicuro di voler confermare?',
    inbound_conveyor_confirm_missing_message: '確認する記事がまだ -missing- 記事がありますが、確認したいですか？',
    ///
    newVersionAvailable: 'Nuova versione disponibile',
    pageWillReload: 'La pagina verrà ricaricata automaticamente tra 30 secondi',
    update_available_description: 'このページではアップデートを利用できます。ページをリロードして更新を適用します。',
    deviceManagerUpdateTitle: 'Device Manager アップデート',
    deviceManagerUpdateDescription:
      '新しい Device Manager アップデートが利用できます。今すぐ更新して、最適な RFID リーダー性能を確認してください。',
    deviceManagerUpdating: 'Device Manager アップデート中。お待ちください、最大5分かかる場合があります。',
    deviceManagerUpdateCompleted: 'アップデートは正常に完了しました',
    deviceManagerUpdateCompletedAndRequiresReboot:
      'アップデートは正常に完了しました。変更を適用するには、PCを再起動してください。',
    exceeded_quantity_message: '生産注文行の数量に達しました。行または生産注文を変更してください。',
    empty_production_order: '生産オーダーに行が存在しません',
    empty_production_order_search: '検索に一致する生産オーダー行がありません'
    ///
  },
  placeholder: {
    search_shipment_parcel: 'シップメントまたはパーセルの検索',
    search_product_parcel: '商品またはパーセルの検索'
  },
  confirm: {
    discrepancy_title: '不一致のあるパーセル',
    discrepancy_message: '相違のある商品が見つかりました。パーセルを確定してもよろしいですか?',
    confirm_delete_association: 'このアイテムの関連付けを削除してもよろしいですか?',
    confirm_delete_operation_title: '{{operation}}を削除',
    confirm_delete_operation: '操作を削除しますか?読み取ったアイテムはすべて失われます。',
    confirm_delete_item_association: 'このアイテムの関連付けを削除してもよろしいですか?',
    confirm_kill_tag: 'このタグを破壊してもよろしいですか?',
    confirm_operation_title: '{{operation}}を確認してください',
    confirm_operation_text: '動作を確定してもよろしいですか？',
    confirm_operation_text_irreversible: '動作を確定してもよろしいですか？この操作は元に戻すことはできません。',
    confirm_operation_text_partial_confirm: '読み取り値を JDE に送信します。続行してもよろしいですか?',
    confirm_operation_text_partial_confirm_without_jde: '続行してもよろしいですか？',
    post_confirm_action_title: '継続',
    post_confirm_action_keep_input: '操作が完了しました。別の操作を実行しますか?',
    post_confirm_action_change_input: '操作が完了しました。別の操作を実行しますか?',
    confirm_multiple_kill_tag: 'すべてのタグを破壊してもよろしいですか？',
    confirm_disassociate_kill_tag: '{{type}}タグ{{tag}}の関連付けを解除して破壊してもよろしいですか？',
    confirm_disassociate_multiple_kill_tag: 'すべてのタグの関連付けを解除して破壊してもよろしいですか？',
    confirm_close_asn_title: 'クローズ確認',
    confirm_close_asn_text: '一部のパーセルが受領されていません。この出荷を強制的にクローズしてもよろしいですか？',
    unpack: 'パーセルは既に梱包されています。アンパックして再度梱包してもよろしいですか？',
    last_parcel_confirmerd: '{{code}} の出荷パッケージをすべて確認しました。出荷も終了しますか?'
    ///
  },
  labels: {
    draft: 'ドラフト',
    ready_to_send: '送信する準備ができました',
    send_await: '保留中',
    outbound_error: 'アウトバウンドエラー',
    sent: '送信済み',
    in_inbound: 'インバウンドで',
    receive_await: '保留中',
    ready_to_receive: '受領',
    inbound_error: 'インバウンドエラー',
    received: '受領済',
    in_transit: '輸送中'
  },
  serverError: {
    //moncler
    WRONG_ITEM_SUPPLIER: '読み取られた一部の商品はサプライヤーで処理できません。',
    QUANTITY_MISMATCH_ERROR: '入力された数量が検出された数量と一致しません。',
    ZONE_MISMATCH_ERROR: '入力されたゾーンが検出されたゾーンと一致しません。'
  },
  error_messages: {
    password_required: 'パスワードフィールドは必須です',
    invalid_password: '無効なパスワード',
    missing_workstation_place: 'ワークステーションの場所が見つかりません',
    connection_in_progress_title: '申し訳ありませんが、接続に失敗しました',
    connection_in_progress_text: '後でもう一度試してください'
  },
  report_tbox: {
    umg: 'Umg',
    ddt_number: 'DDT N.',
    creation_date: '日付',
    capi_mdc: 'キャピ MDC',
    qt_totale: '合計数量',
    qt_accettata: '受領された数量',
    qt_scartata: '拒否された数量',
    supplier: 'サプライヤー',
    notes: 'ノート'
  },
  custom: {
    countTBoxParcel: 'パーセル',
    countTBoxDDT: 'DDT',
    BARCODE_READ: 'バーコード読み取り',
    RFID_START_READING: '読み取りを開始',
    RFID_STOP_READING: '読み取りを中止',
    RESULT_EVENT: 'イベント結果',
    TRACE: 'トレース',
    INFO: '情報',
    WARNING: '警告',
    ERROR: 'エラー',
    deleteSession: 'パーセルの削除',
    deleteSessionMessage: 'パーセルを削除してもよろしいですか?',
    deleteList: 'DDTの削除',
    deleteListMessage: 'ddt を削除してもよろしいですか?',
    WAM: 'SKU',
    sap_warning: 'SAPの警告',
    total_list: '総リスト',
    total_parcel: 'パーセル合計',
    order_number: '注文番号',
    addon: 'アドオン',
    componentType: 'コンポーネントタイプ',
    //cucinelli
    barcode: 'BCバーコード',
    barcodeBCTrim: 'BCバーコードトリム',
    barcodeJDE: 'JDEバーコード',
    barcodeROQ: 'ROQバーコード',
    barcodeROQTrim: 'ROQバーコードトリム',
    class: 'クラス',
    department: '部門',
    dimensionSystem: 'カスタムクラス',
    ean: 'EAN',
    eanIdPadre: '親EAN',
    itemId: 'アイテムID',
    stagioneROQ: 'ROQシーズン',
    subclass: 'モデルタイプ',
    subdepartment: 'サブ部門',
    variantType: 'タイプ',
    variantModel: 'バリアントモデル',
    cardCode: 'カードコード',
    label: 'ラベル',
    rfidEnabled: 'RFID有効',
    stato: 'ステータス',
    ricondizionamentoFornitore: 'サプライヤー再調整',
    codiceShelf: 'ストックコンパートメント',
    montante: 'セクション',
    ripiano: 'ビン',
    scaffale: 'ベイ',
    ASSOCIATED: '関連付け済み',
    NOT_ASSOCIATED: '未関連付け',
    REPLACED_ASSOCIATION: '関連付け置換済み',
    identifiers: '識別子',
    force_parcel: 'パーセルを強制',
    force_parcel_message: 'このパーセルを強制してもよろしいですか？',
    pesa_collo: '重量',
    peso_kg: '重量（kg）',
    wrong_packaging_code: '不正なパッケージコード',
    packaging_confirmed_no_weight: '重さなしで梱包を確定しますか？',
    attention: '注意',
    continue: '続行',
    model: 'モデル',
    sizeCode: 'サイズコード',
    sizeDescription: 'サイズ説明',
    serial: 'シリアル',
    identifier: '識別子',
    product: 'BCバーコード',
    shift: 'シフト',
    destination: '宛先',
    regDate: '日付',
    listPosition: 'リスト位置',
    list: 'リスト',
    customerName: '顧客名',
    regTime: '時間',
    event: 'イベント',
    customer: '顧客',
    isCarryover: '繰越',
    carryoverValue: '繰越値',
    madeIn: '原産地',
    collectionCode: 'コレクション',
    collectionDescription: 'コレクション説明',
    collectionYear: '年',
    fatherProductValue: '親製品',
    genderValue: '性別',
    genderValueDescription: '性別説明',
    line: 'ブランドライン',
    lineDescription: 'ライン説明',
    marchioDescription: 'ブランド説明',
    marchioValue: 'ブランド',
    merchandiseClassCode: 'カテゴリ',
    merchandiseClassDescription: 'カテゴリ説明',
    merchandiseSubclassCode: 'サブカテゴリ',
    merchandiseSubclassDescription: 'サブカテゴリ説明',
    modelPartColor: 'モデルパートカラー',
    modelPartColorSizeValue: 'モデルパートカラーサイズ',
    isPermanent: '永久',
    permanentValue: '永久値',
    isSeasonal: 'シーズン',
    seasonalValue: 'シーズン値',
    sleeveTypeValue: 'スリーブタイプ',
    origin_location_mandatory_field_error: '出発地は必須です',
    transactionDate_mandatory_field_error: '取引日は必須です',
    customerCode_mandatory_field_error: '顧客コードは必須です',
    tipology_field_error: 'タイプは必須です',
    warehouseUsa_relabeling_mandatory_fields_error: 'リボーリングは必須です',
    //valentino
    sconosciuto: '不明',
    prodottoSconosciuto: '不明な製品',
    reads_ok: '読み取りOK',
    tot_to_check: 'チェック対象合計',
    //moncler
    confirm_force_received_text: 'この出荷は既に確定されています。リストから削除しますか？',
    confirm_force_received_sap_text: 'SAPでこの出荷は既に受領されています。リストから削除しますか？',
    confirm_force_received_partially_sap_text:
      'SAPでこの出荷は既に部分的に受領されています。SAPで完了してください。リストから削除しますか？',
    //louis vuitton
    tooManyTags: 'タグが多すぎます',
    nfcDetectedPleaseUseProductControl: 'NFCタグが検出されました。製品管理を使用してください',
    GENERIC_ERROR: '一般的なエラーです - ContactISでサポートに連絡してください',
    ECERTIFICATE_WORKORDER_NOT_FOUND: 'eCertificateで作業指示が見つかりません',
    ITEM_IN_ANOTHER_PARCEL: 'このアイテムは別のパーセルに既にあります',
    ECERTIFICATE_WORKORDER_CREATED_BOT_NOT_COMPLETED: 'eCertificateで作業指示は作成されましたが完了していません',
    INVALID_TIMESTAMP: '無効なタイムスタンプ',
    INVALID_SERIAL: '無効なシリアル番号',
    INVALID_WORKORDER: '無効な作業指示番号',
    INVALID_SKU: '無効なSKU',
    INVALID_PARCEL_NUMBER: '無効なパーセル番号',
    SAP_UCS_NOT_CONFIRMED: '組立ライン終了時にUCS *{parcelCode}が未確定です',
    SAP_REMOVABLE_SYNCHRO_NOT_PERFORMED: 'リムーバブル同期が実行されていません',
    SAP_INCORRECT_OPERATION_STATUS: 'SAP MEでUCS *{parcelCode}のステータスが不正です',
    SAP_COMPLETED_NOT_FOUND_IN_TNT: 'UCSはSAPで完了済みですがT&Tに存在しません',
    SAP_UCS_CANNOT_BE_COMPLETED: 'SAP ME/MIIでUCS *{parcelCode}を完了できません',
    SAP_WORKORDER_CLOSED: 'SAP MIIでUCS *{parcelCode}の作業指示は閉じられています',
    SAP_INTERNAL_ERROR: 'SAP MIIで技術的エラーが発生しました',
    SAP_TIMEOUT_BUT_OK_AGGREGATION: 'タイムアウト→集約は正常です',
    LVSP_PARCEL_NUMBER_ALREADY_AGGREGATED: 'LVSPでパーセル番号が既に集約されています',
    LVSP_SERIAL_ALREADY_AGGREGATED: 'LVSPでシリアル番号が既に集約されています',
    LVSP_MISMATCH_EXPECTED_QUANTITY: 'LVSPで読み取り数量と予想数量が一致しません',
    LVSP_SKU_NOT_FOUND: 'LVSPで未知のSKUです',
    LVSP_SUPPLIER_NOT_FOUND: 'LVSPでサプライヤーが不明です',
    TECHNICAL_ERROR: '技術的問題です - ContactISでサポートに連絡してください',
    ERROR_IN_PARCEL_ITEMS: 'パーセルの確定中にエラーが発生しました。ゴミ箱で空にして再スキャンしてください',
    viewCitesDocument: 'CITES文書を表示',
    LV_LE_ERROR_ON_QUANTITY: 'Limited Edition パーセル数量は1でなければなりません',
    LV_CUSTOM_DECODE_FAILED: 'LVタグデコードに失敗しました',
    ///
    product_is_authentic: '製品は本物です',
    not_sellable: '販売不可です。NeoContactチケットを開いてください。',
    stock_product: '在庫製品：販売可能として保持。顧客返却：返却または交換可能、販売可能として保持。',
    ///
    store_action: '店舗アクション',
    reprint: '再印刷',
    reprint_sent: '再印刷を送信しました',
    row: '行',
    longSKU: 'ロングSKU',
    pairingDate: '生産日時',
    citesFlag: 'CITES',
    pairingSupplier: 'サプライヤー',
    batchNumber: 'バッチ',
    status: 'ステータス',
    chrono: '時系列',
    logisticStatus: '製品ステータス',
    serialNumber: 'RFIDシリアル番号',
    returnCode: '戻りコード',
    // others
    reference: '参照',
    sender: '送信者',
    year: '年',
    number: '番号',
    TAG_STATUS_CONFIRMED: '既に関連付け済み',
    halfpair: 'ハーフペア'
  },
  imbustatrice: {
    and: 'そして',
    unkwon_tag: '不明なタグ',
    dynamic_tag: '{{role}} タグ',
    dynamic_tag_missing: '{{role}} タグがありません',
    too_many_dynamic_tags: '{{role}} タグが多すぎます',
    dynamic_tag_already_associated: '{{role}} タグはすでに関連付けられています',
    wrong_tag: '不正なタグ',
    missing_tag: 'タグがありません'
  },
  identifier_error: {
    ALREADY_ASSOCIATED_TAG: 'すでに関連付けられています',
    TAG_ALREADY_ASSOCIATED_TO_WORKORDERROW: 'ワークオーダー行にすでに関連付けられたタグ',
    WRONG_QC_STATUS: '不正な品質管理ステータス',
    WRONG_QC_SIZE: '不正な品質管理サイズ',
    WRONG_QC_MODEL: '不正な品質管理モデル',
    MISSING_MANDATORY_QC: '品質管理が不足しています',
    MISSING_PRODUCT_INFO: '製品情報がありません',
    WRONG_TAG: '不正なタグ',
    UNKNOWN_TAG: '不明なタグ',
    WRONG_PRODUCT: '不正な製品',
    MISSING_MANDATORY_TAG: '必須タグがありません',
    MISSING_OPTIONAL_TAG: 'オプションのタグがありません',
    EXTRA_TAG: '追加のタグ',
    TAG_MISMATCH: 'タグの不一致',
    PRODUCTIONORDERROW_MISMATCH: '製造オーダー行の関連付けが一致していません',
    MISSING_SYSTEM_TAG: '不明なタグ',
    UNEXPECTED_TAG: '予期しないタグ',
    NOT_EXISTING_CERTILOGO_TAG: 'サーティロゴコードがシステムに存在しません',
    KILLED_TAG: '破壊済みタグ',
    MISSING_TAG: 'Missing tag',
    TOOL_DETECTED: 'Tool tag detected',
    TAG_NOT_PREENCODED: '未プリエンコードタグ'
  },
  statuses: {
    RESTORE_VARIANT: 'タイポロジーを復元',
    CONFIRM_ERROR: '確認エラー'
  },
  userSettings: {
    title: 'ユーザー設定',
    autostopAntennaTimeout: 'アンテナ停止タイムアウト (ms)',
    autostartAntenna: 'アンテナ自動開始',
    autoConfirmParcel: 'パーセル自動確定',
    barcodeItemRead: 'バーコードアイテム読み取り',
    antennas: 'アンテナ設定',
    resetReadingsAfterOperation: '確認後のリセット速度',
    slow: '遅い',
    medium: '中速',
    fast: '速い',
    printerCode: 'プリンターコード',
    enableOkSounds: 'OKサウンド',
    enableKoSounds: 'KOサウンド'
  },
  attributes: {
    material: 'マテリアル',
    workerCode: '作業者コード',
    workerExternalCode: '外部作業者コード',
    workerIdentifier: '作業者識別子',
    workerDescription: '作業者説明',
    workerType: '作業者タイプ',
    orderCode: 'オーダーコード',
    sapQualityControlStatus: 'SAP品質管理ステータス',
    quantityOkWorker: 'OK作業者数量',
    quantityKoWorker: 'KO作業者数量',
    quantityOkRepair: 'OK修理数量',
    quantityOkValdagno: 'OKヴァルダーニョ数量',
    quantityOkFirstInbound: 'OK最初のインバウンド数量',
    quantityOkRis: 'RISK数量',
    quantityKoValdagno: 'KOヴァルダーニョ数量',
    quantitySecondValdagno: 'SECOND CHOICE数量',
    quantityOkLining: 'OKライニング数量',
    quantityKoLining: 'KOライニング数量'
  },
  title: {
    report_problem: '問題を報告する',
    delete_shipment_title: '削除確認'
  },
  subtitle: {
    report_problem: '遭遇した問題を記述するか、改善を提案してください',
    delete_shipment_message: '本当にこの出荷を削除しますか？'
  },
  label: {
    name: '名前',
    email: 'Eメール',
    description: '問題の説明',
    close: '閉じる',
    submit: 'フィードバックを送信'
  },
  success: {
    message: 'フィードバックありがとうございます！'
  },
  button: {
    submit: '送信',
    submitting: '送信中...'
  },
  pre_encoding: {
    correct: '修正',
    correction_title: 'アッパー修正',
    association_extra_right: '右の靴をパッドから離し、左だけを残してください',
    association_extra_left: '左の靴をパッドから離し、右だけを残してください',
    correction_instruction_right: '右の靴をパッドから離し、左だけを置いたままにしてください',
    correction_instruction_left: '左の靴をパッドから離し、右だけを置いたままにしてください',
    epc_reading: 'EPC: 読み取り中....',
    epc_label: 'EPC: {{epc}}',
    write_correction: '修正を書き込む',
    correction_in_progress: '修正中...',
    correction_write_success: '修正が正常に完了しました',
    correction_read_error: 'パッドで1つのタグのみ読み取ってください'
  }
}
